import React from "react";
import Map from "../pages/Map";
import City from "../pages/City";
import Step from "./Step";
import Caravan from "../Caravan";
import clock from "util/clock";
import Locations from "model/locations";
import LocationWrapper from "./Location.style";
import { useGame } from "context/GameContext";
const debug = require("debug")("game:location");

const Location = () => {
  const { gameState } = useGame();
  const { party, location, map, position } = gameState;

  const isParty = Locations.Party.selected(
    location,
    Locations.Party.index,
    party.city,
  );
  const isRoad = Locations.Road.selected(
    location,
    Locations.Road.index,
    party.city,
  );
  const isCity = Locations.City.selected(
    location,
    Locations.City.index,
    party.city,
  );

  return (
    <>
      {isParty && (
        <LocationWrapper isVisible={isParty} name="party">
          <Caravan />
        </LocationWrapper>
      )}

      {map && (
        <LocationWrapper isVisible={isRoad} name="road">
          <Map map={map}>
            <Step
              position={position}
              onClick={() => {
                if (party.caravan.isFull()) clock.toggle();
              }}
            />
          </Map>
        </LocationWrapper>
      )}

      {isCity && (
        <LocationWrapper isVisible={!isRoad && !isParty}>
          <City />
        </LocationWrapper>
      )}
    </>
  );
};

export default Location;
